import { __assign } from "tslib";
import React from 'react';
import { combineMappers } from './combineMappers';
export var DefaultInteractionWrapper = function (_a) {
    var children = _a.children;
    return children;
};
export var getInteractionWrapper = function (_a) {
    var interactions = _a.interactions, context = _a.context;
    return function (_a) {
        var children = _a.children;
        var config = context.config;
        var _b = config.PREVIEW || {}, _c = _b.contentInteractionMappers, contentInteractionMappers = _c === void 0 ? [] : _c, _d = _b.onPreviewExpand, onPreviewExpand = _d === void 0 ? function () { } : _d;
        var interactionMap = combineMappers(contentInteractionMappers, onPreviewExpand);
        return interactions.reduce(function (child, _a) {
            var type = _a.type, settings = _a.settings;
            var Interaction = interactionMap[type] || DefaultInteractionWrapper;
            return (React.createElement(Interaction, __assign({}, settings, context), child));
        }, children);
    };
};
//# sourceMappingURL=getInteractionWrapper.js.map